module.exports = __webpack_public_path__ + "img/Monarch-Architecture2.7b58322f.png";